export function getMaxIntFromTheEndOfString(strs: Array<string>): number {
  const numbers: Array<number> = strs.map((str) => {
    const match = str.match(/\d+$/); // find the digits at the end of the string
    return match ? parseInt(match[0]) : 0; // convert the digits to a number or 0 if not found
  });
  if (numbers.length > 0) return Math.max(...numbers);
  else return 0;
}
